import { OidcConfiguration, OidcProvider as OriginalOidcProvider } from "@axa-fr/react-oidc";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { FC, PropsWithChildren, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { OidcPaths } from "../utils/oidcRoutes";
import { createRedirectUri } from "../utils/oidcUtils";
import { OidcAuthenticating, OidcAuthenticationError, OidcCallbackSuccess, OidcLoading } from "./OidcStateComponents";

export interface OidcProviderProps {
  oidcPaths: OidcPaths;
}

export const OidcProvider: FC<PropsWithChildren<OidcProviderProps>> = ({ children, oidcPaths }) => {
  const configuration: OidcConfiguration = useMemo(
    () => ({
      authority: environment.NX_OIDC_AUTHORITY,
      client_id: environment.NX_OIDC_CLIENT_ID,
      redirect_uri: createRedirectUri(oidcPaths.authorize),
      scope: environment.NX_OIDC_SCOPES,
      storage: localStorage,
    }),
    [oidcPaths.authorize],
  );

  const navigate = useNavigate();
  const onSessionLost = useCallback(
    () => navigate("/" + oidcPaths.sessionLost),
    [navigate, oidcPaths.sessionLost],
  );

  return (
    <OriginalOidcProvider
      configuration={configuration}
      onSessionLost={onSessionLost}
      onLogoutFromAnotherTab={onSessionLost}
      authenticatingComponent={OidcAuthenticating}
      authenticatingErrorComponent={OidcAuthenticationError}
      callbackSuccessComponent={OidcCallbackSuccess}
      loadingComponent={OidcLoading}
    >
      {children}
    </OriginalOidcProvider>
  );
};
